import { ref } from 'vue';

export function useActiveFilters() {
    const activeFilters = ref<string[]>([]);
    const toggleFilter = (filter: string) => {
        const index = activeFilters.value.indexOf(filter);
        if (index > -1) {
            activeFilters.value.splice(index, 1);
        } else {
            activeFilters.value.push(filter);
        }
    };
    return { activeFilters, toggleFilter };
}
